package dev.mft.website.composable.header

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Card
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import mft_website.composeapp.generated.resources.Foto
import mft_website.composeapp.generated.resources.Res
import org.jetbrains.compose.resources.painterResource

@Composable
fun ImageProfile(
    modifierBox: Modifier,
    imageSize: Float
) {
    Box(
        modifier = modifierBox,
        contentAlignment = Alignment.Center
    ) {
        BoxWithConstraints {
            val size = minOf(maxWidth, maxHeight) * imageSize

            Card(
                modifier = Modifier.size(size),
                shape = CircleShape,
                border = BorderStroke(1.dp, Color.Black),
            ) {
                Image(
                    modifier = Modifier.fillMaxSize(),
                    painter = painterResource(Res.drawable.Foto),
                    contentDescription = "My photo",
                    contentScale = ContentScale.Crop,
                )
            }
        }
    }
}